//
//
//
//
//
//
//
//
//
//
//
//

import SfBreadcrumbs from '~/themes/fiskarsMoominDefault/components/components/atoms/SfBreadcrumbs/SfBreadcrumbs.vue';
import { defineComponent, computed, useContext, ref, useRoute } from '@nuxtjs/composition-api';
import { useVSFContext } from "@vue-storefront/core";
import { getCMSLabels } from "~/helpers/globalLabels";

export default defineComponent({
  name: 'CategoryBreadcrumbs',
  components: { SfBreadcrumbs },
  props: {
    categoryBreadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const { localePath } = useVSFContext();
    const { i18n } = useContext();
    const breadcrumbsRef = ref(null);
    const route = useRoute();

    const breadcrumbs = computed(() => ([
      {
        text: getCMSLabels('home') || 'Home (hardcoded)',
        link: localePath('/')
      },
      ...props.categoryBreadcrumbs
    ]));

    const checkOverflow = computed(() => {
      if (!breadcrumbsRef.value) return null;
      let breadcrumbsEl = breadcrumbsRef.value?.querySelector('.moomin-breadcrumbs__list')?.scrollWidth;
      const screenWidth = ref(screen.width);
      if (breadcrumbsEl > screenWidth.value) {
        return true;
      } else {
        return false;
      }
    });

    const isProductDetailPage = computed(() => route && route.name?.includes('product-detail-page'));

    return { breadcrumbs, checkOverflow, breadcrumbsRef, isProductDetailPage };
  }
});
